import React from 'react';
import { FileSignatureIcon, GavelIcon, UsersIcon, RocketIcon, HeadphonesIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { ScrollFadeIn } from './ScrollFadeIn';
const cooperationItems = [{
  key: 'cooperation.item1',
  Icon: FileSignatureIcon
}, {
  key: 'cooperation.item2',
  Icon: GavelIcon
}, {
  key: 'cooperation.item3',
  Icon: UsersIcon
}, {
  key: 'cooperation.item4',
  Icon: RocketIcon
}, {
  key: 'cooperation.item5',
  Icon: HeadphonesIcon
}];
export function CooperationFormat() {
  const {
    t
  } = useLanguage();
  return <section className="w-full bg-graphite py-20 sm:py-28" data-id="element-116">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-117">
        <ScrollFadeIn data-id="element-118">
          <div className="mb-4" data-id="element-119">
            <span className="text-xs font-semibold uppercase tracking-[0.25em] text-electric" data-id="element-120">
              {t('cooperation.label')}
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-extrabold uppercase tracking-tight text-white mb-12" data-id="element-121">
            {t('cooperation.heading')}
          </h2>
        </ScrollFadeIn>

        <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-3" data-id="element-122">
          {cooperationItems.map((item, i) => <ScrollFadeIn key={item.key} delay={i * 60} data-id="element-123">
              <div className="flex flex-col items-center text-center p-5 bg-navy border border-slate-700/50 rounded h-full" data-id="element-124">
                <div className="w-10 h-10 flex items-center justify-center rounded bg-electric/10 mb-3" data-id="element-125">
                  <item.Icon className="w-5 h-5 text-electric" data-id="element-126" />
                </div>
                <span className="text-xs font-semibold text-slate-300 uppercase tracking-wider leading-relaxed" data-id="element-127">
                  {t(item.key)}
                </span>
              </div>
            </ScrollFadeIn>)}
        </div>
      </div>
    </section>;
}